module.exports = __webpack_public_path__ + "static/media/语义搜索支持的单词联想游戏.bc33878f.png";